import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { H4Bold } from '@comeon/ui';
import Icon, { ICON_WE_SPIN } from '~/components/icon/index.js';
import { Sidebar, SidebarHeader, SidebarContent } from '../../../sidebar/index.js';
import IconArrowLinkLeft from '../../../misc/icon-arrow-link-left';
import { setOnsiteAdNotificationsEnabled, fetchAdNotificationsEnabled } from '../ducks/we-spin-duck.js';
import useTranslations from '../../../translation/use-translations';
import { WE_SPIN_ACCOUNT_TEXT_KEYS } from '../constants/we-spin-text-keys.js';
import { selectIsAdNotificationsEnabled } from '../ducks/we-spin-selectors.js';
import { HeadWrapper, MainTitle, SubTitle } from '../../../misc/section-head.js';
import CheckBox from '../../../forms/checkbox';

const WeSpinNotificationOptOut = () => {
	const dispatch = useDispatch();
	const isAdNotificationsEnabled = useSelector(selectIsAdNotificationsEnabled);
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_ACCOUNT_TEXT_KEYS);
	const handleChange = useCallback(() => {
		dispatch(setOnsiteAdNotificationsEnabled(!isAdNotificationsEnabled)).then(() =>
			dispatch(fetchAdNotificationsEnabled())
		); // if the POST request were to return a value we would not need to do the second request
	}, [dispatch, isAdNotificationsEnabled]);

	if (isLoadingTranslations) return null;

	return (
		<div className="modal-view">
			<Sidebar>
				<SidebarHeader
					transparent
					Icon={<IconArrowLinkLeft href="/account/settings" className="js-back page-head__back u-show" />}
				>
					<H4Bold className="page-head__title" />
					<div className="page-head__right-side" />
				</SidebarHeader>
				<SidebarContent>
					<HeadWrapper>
						<Icon type={ICON_WE_SPIN} />
						<MainTitle>{tr.WE_SPIN_ACCOUNT_NOTIFICATION_OPT_OUT_TITLE}</MainTitle>
						<SubTitle>{tr.WE_SPIN_ACCOUNT_NOTIFICATION_OPT_OUT_MESSAGE}</SubTitle>
					</HeadWrapper>
					<div className="section u-pl1 u-pr1 u-pb-xl">
						<ul className="custom-checkbox-list">
							<li>
								<CheckBox
									id="WeSpinNotifications"
									isChecked={isAdNotificationsEnabled}
									label={tr.WE_SPIN_ACCOUNT_NOTIFICATIONS_SETTINGS_LABEL}
									iconPosition="right"
									onChange={handleChange}
								/>
							</li>
						</ul>
					</div>
				</SidebarContent>
			</Sidebar>
		</div>
	);
};

export default WeSpinNotificationOptOut;
